import React, { forwardRef } from "react";
import styles from "./blueprint-table-body-flex-wrapper-with-description-popover-button.module.scss";
import { BlueprintDescriptionPopoverButtonWrapper } from "../blueprint-description-popover-button-wrapper/blueprint-description-popover-button-wrapper";
import { BlueprintsArrayObjectTypes } from "@common/types/blueprint-types";
import { PopoverPositionObjectTypes } from "../blueprint-table-body/blueprint-table-body";
import { FlexRowContainer } from "@src/components/templates/layouts/flex-row-container/flex-row-container";

const cssClassName =
  "blueprint-table-body-flex-wrapper-with-description-popover-button";

interface BlueprintTableBodyFlexWrapperWithDescriptionPopoverButtonPropTypes {
  blueprint: BlueprintsArrayObjectTypes;
  popoverPositionCallback: (coordinates: PopoverPositionObjectTypes) => void;
  activePopoverCallback: (blueprint: BlueprintsArrayObjectTypes) => void;
  activeBlueprintCallback: (blueprint: BlueprintsArrayObjectTypes) => void;
}

export const BlueprintTableBodyFlexWrapperWithDescriptionPopoverButton =
  forwardRef(
    (
      {
        blueprint,
        popoverPositionCallback,
        activePopoverCallback,
        activeBlueprintCallback,
      }: BlueprintTableBodyFlexWrapperWithDescriptionPopoverButtonPropTypes,
      ref: React.Ref<HTMLDivElement>,
    ) => {
      return (
        <FlexRowContainer horizontalGap={4}>
          <span className={styles[`${cssClassName}__text`]}>
            {blueprint.name}
          </span>
          {blueprint.description && (
            <BlueprintDescriptionPopoverButtonWrapper
              ref={ref}
              blueprint={blueprint}
              popoverPositionCallback={popoverPositionCallback}
              activePopoverCallback={activePopoverCallback}
              activeBlueprintCallback={activeBlueprintCallback}
            />
          )}
        </FlexRowContainer>
      );
    },
  );

BlueprintTableBodyFlexWrapperWithDescriptionPopoverButton.displayName =
  "BlueprintTableBodyFlexWrapperWithDescriptionPopoverButton";
